/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IAhiSubcategoryResultsContainerData } from './ahi-subcategory-results-container.data';
import { IAhiSubcategoryResultsContainerProps } from './ahi-subcategory-results-container.props.autogenerated';
import { ISubCategoryStructureEntity } from '../../actions/DataServiceEntities.g';
import { CategoryHierarchy } from '@msdyn365-commerce/commerce-entities';
import SubCategoryCard from './components/subcategory-card';

export interface IAhiSubcategoryResultsContainerViewProps
    extends IAhiSubcategoryResultsContainerProps<IAhiSubcategoryResultsContainerData> {
    subCategoryCards?: JSX.Element | JSX.Element[];
    currentCategoryHierarchy?: CategoryHierarchy[];
}

/**
 *
 * AhiSubcategoryResultsContainer component
 * @extends {React.PureComponent<IAhiSubcategoryResultsContainerProps<IAhiSubcategoryResultsContainerData>>}
 */
const AhiSubcategoryResultsContainer: React.FC<IAhiSubcategoryResultsContainerProps<IAhiSubcategoryResultsContainerData>> = props => {
    const currentCategory = props.data.currentCategory.result;

    const getSubCategoryCards = (subCategories?: ISubCategoryStructureEntity[]) => {
        if (!subCategories || !Boolean(subCategories?.length)) {
            return (
                <div className='empty-result-container'>
                    <span className='empty-message'>{props.resources.subcategoryEmptyResultMessage}</span>
                </div>
            );
        }
        const sortedSubcatgories = subCategories.sort((a, b) => a.DISPLAYORDER - b.DISPLAYORDER);
        // console.log('SubCategories -->', subCategories);
        // console.log('SortedSubCategories -->', sortedSubcatgories);

        const subCategoryCards =
            subCategories &&
            sortedSubcatgories &&
            sortedSubcatgories.map(subCategory => {
                const subcategoryHierarchy = currentCategory?.Children.find(category => category.RecordId === subCategory.RECID);
                const subCategoryLink = subcategoryHierarchy?.Url;
                const imageUrl = encodeURI(`Categories/${subCategory.NAME}.png`);
                const imgSrc = `${props.context.request.apiSettings.baseImageUrl}${imageUrl}`;
                return (
                    <SubCategoryCard
                        imageUrl={imgSrc}
                        imageSettings={props.config.subCategoryImageSettings}
                        subCategoryDescription={subCategory.DESCRIPTION}
                        subCategoryName={subCategory.NAME}
                        subCategoryLinkText={props.resources.categoryDetailsLinkText}
                        subCategoryDetailsLink={subCategoryLink}
                        context={props.context.request}
                        key={subCategory.RECID}
                    />
                );
            });
        return subCategoryCards;
    };
    let viewProps: IAhiSubcategoryResultsContainerViewProps = {
        ...props,
        subCategoryCards: getSubCategoryCards(props.data.subCategories?.result)
    };
    return props.renderView(viewProps);
};

export default AhiSubcategoryResultsContainer;
